const map = {
	"./RF-2.png": 6982,
	"./Realflame Website Pictures (1).png": 7758,
	"./Realflame Website Pictures (2).png": 8815,
	"./Realflame Website Pictures (5).png": 2850,
	"./Realflame Website Pictures (7).png": 9084
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2533;